import React, { useState, useEffect, useContext } from 'react';
import IndiaMap from './IndiaMap';
import TransactionSidebar from './TransactionSidebar';
import LeftPanel from './LeftPanel';
import { DataContext } from '../data/DataContext';
const berryCareLogo = './berrycare2.png';

function BerryPulseLayout() {
  const [hoverDataList, setHoverDataList] = useState([]);
  const { data } = useContext(DataContext)
  const LOADING_GIF_URL = "/loader3.gif";


  useEffect(() => {
    if (data != null)
      setHoverDataList(data.data?.hoverDataList || []);
  }, [data])
  // useEffect(() => {
  //   const API_URL = `${process.env.REACT_APP_API}/impact/`;

  //   fetch(API_URL)
  //     .then(response => response.json())
  //     .then(data => {
  //       console.log('Full API response:', data);
  //       setHoverDataList(data.data?.hoverDataList || []);
  //     })
  //     .catch(error => console.error('Fetch error:', error));
  // }, []);

  if (!data) {
    return <img
      src={LOADING_GIF_URL}
      alt="Loading..."
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "100px", // Adjust size if needed
        height: "100px",
        objectFit: "contain"
      }} />
  }
  return (
    <div
      style={{
        fontFamily: 'Open Sans, sans-serif',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#F5F5F5'
      }}
    >
      {/* TOP BAR */}
      <header
        style={{
          height: '60px',
          backgroundColor: '#4A2D7D',
          display: 'flex',
          alignItems: 'center',
          padding: '0 1rem',
        }}
      >
        <img
          src={berryCareLogo}
          alt="berry.care Logo"
          style={{ height: '60px', marginRight: '1rem' }}
        />
        <h1 style={{ color: '#fff', margin: 0, fontSize: '1.3rem' }}>
          Impact by berry.care
        </h1>
      </header>

      {/* MAIN CONTENT */}
      <div style={{
        flex: 1,
        display: 'flex',
        gap: '2rem',
        padding: '1rem',


      }}>
        {/* Left Panel */}
        {/* <div style={{ marginBottom: '1rem' }}> */}
        <LeftPanel />
        {/* </div> */}

        {/* Map Section */}
        <div style={{
          flex: 1,
          backgroundColor: '#1b1b38',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          // backgroundColor:"#1b1b38"
        }}>
          <h2 style={{
            margin: '1rem',
            color: '#fff',
            fontSize: '1.1rem',
            textAlign: 'center',
            
          }}>
            Our presence across the country
          </h2>
          <div style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <IndiaMap hoverDataList={hoverDataList} />
          </div>
        </div>

        {/* Right Panel */}
        <div style={{ marginBottom: '10rem' }}>
          <TransactionSidebar hoverData={hoverDataList} />
        </div>
      </div>
    </div>
  );
}

export default BerryPulseLayout;